/* eslint-disable no-await-in-loop */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import { defaultRetryDelayHandler, pause } from './withRetries.js';
/**
 * Custom error type that collects retry errors
 */
export class RetryError extends Error {
    constructor(message, errors) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = 'RetryError';
        this._errors = errors;
    }
    get errors() {
        return this._errors;
    }
}
/**
 *  create a retry function with defaults
 */
export function defaultNetworkErrorRetryHandler({ maxRetries = 3 }) {
    return ({ retryCount }) => retryCount <= maxRetries;
}
/**
 * Fetch middleware to introduce retry operations based on provided settings
 */
export function withNetworkErrorRetries({ retry = defaultNetworkErrorRetryHandler({}), delay = defaultRetryDelayHandler({ initialDelay: 100 }), onRetryEvent } = {}) {
    return async ({ url, init, fetch, error }) => {
        let retryCount = 1;
        const errors = [error];
        while (await retry({ retryCount })) {
            const delayAmount = await delay({ retryCount });
            await pause(delayAmount);
            if (onRetryEvent) {
                await onRetryEvent({ retryCount });
            }
            try {
                // try again with provided fetch
                return await fetch(url, init);
            }
            catch (err) {
                errors.push(err);
            }
            retryCount++;
        }
        // Retries exhausted, throw an error.
        throw new RetryError('Too many retries', errors);
    };
}
//# sourceMappingURL=withNetworkErrorRetries.js.map